export const favoritesHeaderText = "RPRnjc";
export const favoritesWithAccountNameHeaderText = "xDKXTd";
export default {favoritesHeaderText,favoritesWithAccountNameHeaderText};